
import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import "./App.css";

// =========================================
// EXISTING MBIM IMPORTS
// =========================================

import Projects from "./pages/Projects";
import Login from "./pages/Login";
import Register from "./pages/Register";
import RegisterCompany from "./pages/RegisterCompany";
import ProjectDashboard from "./pages/ProjectDashboard";
import CompanyAddUser from "./pages/CompanyAddUser";

import {
  SessionProvider as MBIMSessionProvider,
} from "./context/SessionContext";

import BoqPage from "./components/BoqPage";
import BOMPage from "./components/BOMPage";
import SecondtabPanel from "./pages/SecondtabPanel";
import ThirdtabPanel from "./pages/ThirdtabPanel";
import API from "./services/api";

import ForgotPasswordPage from "./components/ForgotPasswordPage";
import ResetPasswordPage from "./components/ResetPasswordPage";
import FourthPanel from "./pages/FourthPanel";
import FifthPanel from "./pages/FifthPanel";
import ActivityBOMPage from "./components/ActivityBOMPage";
import WbsBOMPage from "./components/WbsBOMPage";
import RegisterNewCompany from "./pages/RegisterNewCompany";
import SuperAdminCompanies from "./pages/SuperAdminCompanies";
import BaevrDesktopLogin from "./pages/BaevrDesktopLogin";
import BaevrCompanySelection from "./pages/BaevrCompanySelection";
import BaevrProjects from "./ItemizerProjects/BaevrProjects";
import BaevrWbs from "./ItemizerProjects/BaevrWbs";
// =========================================
// CONTRACT IMPORTS
// =========================================

import CreateTender from "./Contracts/pages/CreateTender";
import ProjectContracts from "./Contracts/pages/ProjectContracts";

import MainViewLayout from "./Contracts/Components/MainViewLayout";

import PageLayout, {
  type PageLayoutHeaderActions,
} from "./Contracts/Components/PageLayout";

import SecondScreenLayout from "./Contracts/Components/SecondScreenLayout";

import {
  SessionProvider as ContractsSessionProvider,
} from "./Contracts/Contexts/SessionContext";

// =========================================
// MBIM AUTHENTICATION
// =========================================

const PrivateRoute = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let active = true;

    API.get("/auth/me")
      .then(() => {
        if (active) {
          setAuthenticated(true);
        }
      })
      .catch(() => {
        if (active) {
          setAuthenticated(false);
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return authenticated ? (
    <>{children}</>
  ) : (
    <Navigate to="/login" replace />
  );
};

// =========================================
// CONTRACT TENDER DETAILS SCREEN
// =========================================

function TenderScreen() {
  const [headerActions, setHeaderActions] =
    useState<PageLayoutHeaderActions | null>(null);

  return (
    <SecondScreenLayout headerActions={headerActions}>
      <PageLayout
        onRegisterHeaderActions={setHeaderActions}
      />
    </SecondScreenLayout>
  );
}

// =========================================
// MAIN APPLICATION
// =========================================

function App() {
  return (
    <MBIMSessionProvider>
      <BrowserRouter>
        <Routes>
          {/* =========================================
              PUBLIC MBIM ROUTES
              ========================================= */}

          <Route
            path="/login"
            element={<Login />}
          />

          <Route
            path="/baevr-desktop"
            element={<BaevrDesktopLogin />}
          />

          <Route
            path="/baevr-company-selection"
            element={<BaevrCompanySelection />}
          />

          <Route
            path="/register"
            element={<Register />}
          />

          <Route
            path="/register-company"
            element={<RegisterCompany />}
          />

          <Route
            path="/forgot-password"
            element={<ForgotPasswordPage />}
          />

          <Route
            path="/reset-password"
            element={<ResetPasswordPage />}
          />

          {/* =========================================
              EXISTING MBIM PROJECT ROUTES
              ========================================= */}

          {/* <Route
            path="/"
            element={
              <PrivateRoute>
                <Projects />
              </PrivateRoute>
            }
          /> */}
          <Route
  path="/"
  element={
    <PrivateRoute>
      <ContractsSessionProvider>
        <Projects />
      </ContractsSessionProvider>
    </PrivateRoute>
  }
/>

<Route
  path="/baevr-projects"
  element={
    <PrivateRoute>
      <ContractsSessionProvider>
        <BaevrProjects />
      </ContractsSessionProvider>
    </PrivateRoute>
  }
/>

<Route
  path="/baevr-wbs/:projectId"
  element={
    <PrivateRoute>
      <BaevrWbs />
    </PrivateRoute>
  }
/>

          <Route
            path="/register-new-company"
            element={
              <PrivateRoute>
                <RegisterNewCompany />
              </PrivateRoute>
            }
          />

          <Route
            path="/project/:id"
            element={
              <PrivateRoute>
                <ProjectDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/project/:id/second"
            element={
              <PrivateRoute>
                <SecondtabPanel />
              </PrivateRoute>
            }
          />

          <Route
            path="/project/:id/third"
            element={
              <PrivateRoute>
                <ThirdtabPanel />
              </PrivateRoute>
            }
          />

          <Route
            path="/project/:id/fourth"
            element={
              <PrivateRoute>
                <FourthPanel />
              </PrivateRoute>
            }
          />

          <Route
            path="/project/:id/fifth"
            element={
              <PrivateRoute>
                <FifthPanel />
              </PrivateRoute>
            }
          />

          <Route
            path="/boq/:wbs"
            element={
              <PrivateRoute>
                <BoqPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/bom/:wbs"
            element={
              <PrivateRoute>
                <BOMPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/activity-bom"
            element={
              <PrivateRoute>
                <ActivityBOMPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/wbs-bom"
            element={
              <PrivateRoute>
                <WbsBOMPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/super-admin"
            element={
              <PrivateRoute>
                <SuperAdminCompanies />
              </PrivateRoute>
            }
          />

          <Route
            path="/add-user"
            element={
              <PrivateRoute>
                <CompanyAddUser />
              </PrivateRoute>
            }
          />

          {/* =========================================
              CONTRACTS SHARED LAYOUT ROUTES
              Project Contracts and Create Tender
              ========================================= */}

          <Route
            element={
              <PrivateRoute>
                <ContractsSessionProvider>
                  <MainViewLayout />
                </ContractsSessionProvider>
              </PrivateRoute>
            }
          >
            <Route
              path="/projects/:projectNo/contracts"
              element={<ProjectContracts />}
            />

            <Route
              path="/create-tender"
              element={<CreateTender />}
            />
          </Route>

          {/* =========================================
              CONTRACT TENDER DETAILS
              Uses the original SecondScreenLayout
              ========================================= */}

          <Route
            path="/tenders/:tenderNo"
            element={
              <PrivateRoute>
                <ContractsSessionProvider>
                  <TenderScreen />
                </ContractsSessionProvider>
              </PrivateRoute>
            }
          />

          {/* =========================================
              DEFAULT ROUTE
              ========================================= */}

          <Route
            path="*"
            element={<Navigate to="/" replace />}
          />
        </Routes>
      </BrowserRouter>
    </MBIMSessionProvider>
  );
}

export default App;
